import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PostmethodService } from '../app-config/postmethod.service';
import { RequestModel } from '../models/RequestModel';
import { SessionKeys } from './../app-config/SessionKeys';

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  constructor( private ws:PostmethodService ) { }
  validateUser(request:any,iv:string) {
    return this.ws.wsPostNoToken(request, environment.commonServiceUrl+"login",iv);
  }

  getPermission(request:RequestModel , iv:string){
    return this.ws.wsPost(request,environment.webServiceUrl+"getuserpermission",iv );
  }
  
  removeToken(){
    sessionStorage.removeItem(SessionKeys.autho_token);
    sessionStorage.removeItem(SessionKeys.userDetail);
    sessionStorage.removeItem(SessionKeys.USER);
    sessionStorage.removeItem(SessionKeys.Menu_Details);
}
}
